import React from "react";

/**
 * Flex Line wordmark logo. Renders the brand SVG (icon + "Flex Line").
 * Pass `dark` on dark backgrounds for the white variant. Size via `className` height (w-auto).
 */
export function Logo({ dark = false, withText = true, className = "h-8", onClick }) {
    const src = withText
        ? dark
            ? "/flexline-wordmark-white.svg"
            : "/flexline-wordmark.svg"
        : "/favicon.svg";
    return (
        <img
            src={src}
            alt="Flex Line"
            onClick={onClick}
            data-testid="flexline-logo"
            className={`${className} w-auto ${onClick ? "cursor-pointer" : ""}`}
        />
    );
}

export default Logo;
